import { render, staticRenderFns } from "./SupplierTagsList.vue?vue&type=template&id=fb83a02a&scoped=true&"
import script from "./SupplierTagsList.vue?vue&type=script&lang=js&"
export * from "./SupplierTagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb83a02a",
  null
  
)

export default component.exports